export function deleteFormDataCookie() {
	window.modUtils.deleteCookie('formData');
}
